import { DataRoomAccessPermission, DataRoomStatus } from './data-room.enums';
import { SpaceKind } from './space.enums';
import { DataRoomListItem, WorkspaceListItem, WorkspaceMetrics } from './space-list-view.types';

export interface SpaceNavigationRoot {
  children: SpaceNavigationFolder[];
  createdAt: null | string;
  hasChildren: boolean;
  id: string;
  isLocked: boolean;
  kind: SpaceKind;
  name: string;
  permission?: DataRoomAccessPermission;
  rootFolderId: null | string;
  status: DataRoomStatus | null;
}

export interface SpaceNavigationView {
  dataRooms: SpaceNavigationRoot[];
  vault: SpaceNavigationRoot;
  workspaces: SpaceNavigationRoot[];
}

export interface SpaceNavigationFolder {
  // Present only when the level was asked for with `depth: 2`.
  children?: SpaceNavigationFolder[];
  hasChildren: boolean;
  id: string;
  name: string;
  parentFolderId: null | string;
}

export const VAULT_SPACE_NAME = 'My Vault';

// The Vault has no row of its own: its dates come from its system folders, null while it has none.
export interface VaultSpaceView {
  createdAt: null | string;
  description: null;
  id: string;
  isLocked: true;
  kind: SpaceKind.VAULT;
  metrics: WorkspaceMetrics;
  name: string;
  rootFolderId: null;
  updatedAt: null | string;
}

export interface SpaceHomeView {
  dataRoomCount: number;
  dataRooms: DataRoomListItem[];
  vault: VaultSpaceView;
  workspaces: WorkspaceListItem[];
}
